import { render, staticRenderFns } from "./DutyClose.vue?vue&type=template&id=3d731bae"
import script from "./DutyClose.vue?vue&type=script&lang=js"
export * from "./DutyClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports